export const meta = {
  title: 'Window display',
  icon: '/favicon.png',
  description: 'Window display',
} as const

const CUSTOM_META_ROUTES = [
  '/[slug]',
  '/preview/[...slug]',
  '/boutique/[...slug]',
  '/outfits/[...slug]',
]

export function isCustomMetaRoute(route: string) {
  return CUSTOM_META_ROUTES.includes(route)
}
